import { reportClientError } from '~/composables/useErrorReporter'

export type ProgressionAnalyticsEvent =
  | 'chapter_complete'
  | 'chapter_dismiss'
  | 'visibility_hidden'
  | 'visibility_visible'
  | 'offline_report_claimed'
  | 'capstone_defeated'
  | 'onboarding_step_complete'
  | 'onboarding_skipped'
  | 'funnel_campaign_champion'
  | 'funnel_reserve_complete'
  | 'funnel_first_ascension'

/** Traces produit pour filtrage admin (kind lifecycle_trace + meta.event). */
export function trackProgressionEvent(
  event: ProgressionAnalyticsEvent,
  meta?: Record<string, unknown>
): void {
  void reportClientError({
    kind: 'lifecycle_trace',
    message: `progression:${event}`,
    meta: { event, ...meta },
  })
}
